import { render, staticRenderFns } from "./phone_add.vue?vue&type=template&id=1a714f4f&"
import script from "./phone_add.vue?vue&type=script&lang=ts&"
export * from "./phone_add.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports